import type { FooterRebrushContext, FooterRebrushVisibility } from "./footer-rebrush-types"

function hasAny(values?: unknown[]): boolean {
  return Array.isArray(values) && values.length > 0
}

export function isFooterRebrushExcludedByCountry(
  blok: FooterRebrushVisibility | undefined,
  context: Pick<FooterRebrushContext, "country">
) {
  return !!blok && hasAny(blok.countries_exclude) && blok.countries_exclude?.includes(context.country)
}

export function hasFooterRebrushContextVisibility(blok: FooterRebrushVisibility | undefined) {
  return !!(blok?.show_on_oci || blok?.show_on_non_oci || blok?.show_on_b2b || blok?.show_on_b2c)
}

export function isFooterRebrushVisible(blok: FooterRebrushVisibility | undefined, context: FooterRebrushContext) {
  if (!blok) {
    return true
  }

  if (isFooterRebrushExcludedByCountry(blok, context)) {
    return false
  }

  const contextMatches: boolean[] = []

  if (!!blok.show_on_oci || !!blok.show_on_non_oci) {
    contextMatches.push((!!blok.show_on_oci && context.isOCI) || (!!blok.show_on_non_oci && !context.isOCI))
  }

  if (!!blok.show_on_b2b || !!blok.show_on_b2c) {
    contextMatches.push((!!blok.show_on_b2b && context.isB2B) || (!!blok.show_on_b2c && !context.isB2B))
  }

  if (contextMatches.length === 0) {
    return true
  }

  return blok.match_all ? contextMatches.every(Boolean) : contextMatches.some(Boolean)
}

export function filterVisibleFooterRebrushItems<T extends FooterRebrushVisibility>(
  items: T[] | undefined,
  context: FooterRebrushContext
) {
  return items?.filter((item) => isFooterRebrushVisible(item, context)) ?? []
}

export function filterFooterRebrushItemsByCountry<T extends FooterRebrushVisibility>(
  items: T[] | undefined,
  context: Pick<FooterRebrushContext, "country">
) {
  return items?.filter((item) => !isFooterRebrushExcludedByCountry(item, context)) ?? []
}
